import { StyleSheet, Platform } from 'react-native';
import { ORANGE_ACTION } from '@cubemeet/ui';

const ORANGE = ORANGE_ACTION;

export default StyleSheet.create({
  container: { flex: 1, padding: 0, margin: 0, position: 'relative', width: '100%', backgroundColor: '#F3F4F6' },
  
  mainContainer: {
    flex: 1,
    width: '100%',
    maxWidth: 600,
    alignSelf: 'center',
    backgroundColor: '#fff',
    borderRadius: 12,
    marginTop: 0,
    marginBottom: 20,
    overflow: 'hidden',
    ...Platform.select({
      web: {
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        minHeight: '100vh',
      },
      default: {
        elevation: 4,
      }
    }),
  },

  // center page content on wide screens (match CreateTravel/TravelDetail)
  pageInner: {
    width: '100%',
    // maxWidth: 600, // Removed as mainContainer handles width
    // alignSelf: 'center', // Removed as mainContainer handles alignment
  },
  // ensure header has space below it so content doesn't overlap
  headerContainer: { position: 'relative', height: 182, marginBottom: 0, zIndex: 100 },
  tabsContainer: { paddingVertical: 8, paddingHorizontal: 4 },
  dayTab: { paddingHorizontal: 12, paddingVertical: 8, backgroundColor: '#F3F4F6', borderRadius: 20, marginRight: 8, alignItems: 'center' },
  dayTabActive: { backgroundColor: ORANGE },
  dayTabTitle: { fontSize: 13, color: '#374151', fontWeight: '600' },
  dayTabTitleActive: { color: '#fff' },
  dayTabSub: { fontSize: 12, color: '#6B7280', marginTop: 4 },

  richCardContainer: {
    backgroundColor: '#fff',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    overflow: 'hidden',
    marginBottom: 12,
    ...Platform.select({
      web: { boxShadow: '0 4px 12px rgba(15,23,42,0.06)' },
      default: {
        shadowColor: '#0F172A',
        shadowOpacity: 0.06,
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 12,
        elevation: 2,
      }
    }),
  },
  legacyCardContainer: {
    backgroundColor: '#fff',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    paddingVertical: 16,
    paddingHorizontal: 18,
    marginBottom: 12,
    ...Platform.select({
      web: { boxShadow: '0 4px 12px rgba(15,23,42,0.06)' },
      default: {
        shadowColor: '#0F172A',
        shadowOpacity: 0.06,
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 12,
        elevation: 2,
      }
    }),
  },
  cardBody: { paddingVertical: 16, paddingHorizontal: 16 },
  cardHeaderRow: { flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 8 },
  cardTitleRow: { flexDirection: 'row', alignItems: 'center', flex: 1, marginRight: 12 },
  cardTypeIcon: { 
    width: 32, 
    height: 32, 
    borderRadius: 16, 
    alignItems: 'center', 
    justifyContent: 'center', 
    marginRight: 10,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  cardTitle: { flex: 1, fontSize: 16, fontWeight: '600', color: '#111827', lineHeight: 22 },
  cardExpandButton: { 
    width: 24, 
    height: 24, 
    alignItems: 'center', 
    justifyContent: 'center',
  },
  cardExpandToggle: {
    marginTop: 8,
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#E5E7EB',
    alignSelf: 'stretch',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardExpandToggleText: {
    fontSize: 14,
    fontWeight: '600',
    color: ORANGE,
  },
  
  editModeWrapper: { marginBottom: 12 },
  editModeActions: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 12, paddingVertical: 12, paddingHorizontal: 12, backgroundColor: '#F9FAFB', borderBottomWidth: 1, borderBottomColor: '#E5E7EB', borderBottomLeftRadius: 16, borderBottomRightRadius: 16, marginTop: -1 },
  editModeButton: { flex: 1, height: 44, alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff', borderRadius: 8, borderWidth: 1, borderColor: '#E5E7EB' },
  
  cardLocationRow: { flexDirection: 'row', alignItems: 'center', marginBottom: 12 },
  cardLocationText: { marginLeft: 6, fontSize: 13, color: '#6B7280', lineHeight: 18, flex: 1 },
  cardExpandedContent: { marginTop: 8 },
  cardDescription: { fontSize: 14, color: '#374151', lineHeight: 20, marginBottom: 12 },
  cardHighlightBlock: { marginTop: 8, backgroundColor: '#F9FAFB', borderRadius: 10, paddingVertical: 10, paddingHorizontal: 12, marginBottom: 12 },
  cardHighlightLine: { fontSize: 13, color: '#1F2937', lineHeight: 18, marginBottom: 4 },
  cardMetaBlock: { marginTop: 8, flexDirection: 'row', flexWrap: 'wrap', marginBottom: 12 },
  cardMetaRow: { flexDirection: 'row', alignItems: 'center', borderWidth: 1, borderColor: '#E5E7EB', borderRadius: 8, paddingVertical: 4, paddingHorizontal: 8, marginRight: 8, marginBottom: 6, backgroundColor: '#fff' },
  cardMetaLabel: { fontSize: 11, fontWeight: '600', color: '#374151', marginRight: 4 },
  cardMetaValue: { fontSize: 11, color: '#374151' },
  cardTagList: { marginTop: 8, flexDirection: 'row', flexWrap: 'wrap' },
  cardTagPill: { backgroundColor: '#EEF2FF', borderRadius: 12, paddingVertical: 3, paddingHorizontal: 8, marginRight: 6, marginBottom: 6 },
  cardTagText: { fontSize: 11, fontWeight: '500', color: '#4338CA' },

  modernPOICard: {
    backgroundColor: '#fff',
    borderRadius: 20,
    overflow: 'hidden',
    marginBottom: 24,
    ...Platform.select({
      web: { boxShadow: '0 8px 24px rgba(0,0,0,0.08)' },
      default: {
        shadowColor: '#000',
        shadowOpacity: 0.08,
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 16,
        elevation: 4,
      }
    }),
  },
  poiImageSection: {
    height: 160,
    position: 'relative',
  },
  poiImage: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
  },
  poiContent: {
    padding: 16,
    position: 'relative',
  },
  poiTitleRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  poiTextSection: {
    flex: 1,
    marginRight: 12,
  },
  poiTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1F2937',
    lineHeight: 24,
    marginBottom: 6,
  },
  poiLocationRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  poiLocationText: {
    marginLeft: 6,
    fontSize: 14,
    color: '#6B7280',
    lineHeight: 20,
    flex: 1,
  },
  poiExpandButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#F3F4F6',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-end',
  },
  poiExpandButtonBottomRight: {
    position: 'absolute',
    bottom: 16,
    right: 16,
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#F3F4F6',
    alignItems: 'center',
    justifyContent: 'center',
  },
  poiExpandedSection: {
    borderTopWidth: 1,
    borderTopColor: '#F3F4F6',
    paddingTop: 16,
    marginTop: 16,
  },
  poiInfoBlock: {
    marginBottom: 16,
  },
  poiInfoHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  poiInfoTitle: {
    marginLeft: 8,
    fontSize: 15,
    fontWeight: '600',
    color: '#374151',
  },
  poiInfoContent: {
    fontSize: 14,
    color: '#4B5563',
    lineHeight: 22,
  },
  poiMetaItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: '#F9FAFB',
  },
  poiMetaLabel: {
    fontSize: 13,
    color: '#6B7280',
    fontWeight: '500',
  },
  poiMetaValue: {
    fontSize: 13,
    color: '#111827',
    fontWeight: '600',
  },
  poiHighlightItem: {
    fontSize: 13,
    color: '#374151',
    lineHeight: 20,
    marginBottom: 4,
  },
  poiTagsSection: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 16,
  },
  poiTag: {
    backgroundColor: '#EEF2FF',
    borderRadius: 12,
    paddingVertical: 4,
    paddingHorizontal: 10,
    marginRight: 6,
    marginBottom: 6,
  },
  poiTagText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#4338CA',
  },
  poiActionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#3B82F6',
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  poiActionButtonText: {
    marginLeft: 6,
    fontSize: 14,
    fontWeight: '600',
    color: '#fff',
  },

  // modest top padding so first card isn't flush against header
  timelineScroll: { marginTop: 12, flex: 1 },
  timelineContent: { paddingTop: 12, paddingBottom: 100, paddingLeft: 16, paddingRight: 12 },
  // spacing between individual item cards (reduced slightly)
  itemCard: { backgroundColor: '#fff', borderRadius: 12, paddingVertical: 16, paddingHorizontal: 12, marginBottom: 16, ...Platform.select({ web: { boxShadow: '0 8px 20px rgba(0,0,0,0.06)' }, default: { shadowColor: '#000', shadowOpacity: 0.06, shadowOffset: { width: 0, height: 8 }, shadowRadius: 20, elevation: 2 } }) },
  itemRowTop: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' },
  itemTitle: { fontSize: 16, fontWeight: '600', color: '#111827' },
  itemActions: { flexDirection: 'row', alignItems: 'center' },
  iconBtn: { padding: 8, marginLeft: 6 },
  itemNote: { marginTop: 8, color: '#6B7280' },

  fab: { position: 'absolute', right: 24, bottom: 24, width: 48, height: 48, borderRadius: 24, backgroundColor: ORANGE, alignItems: 'center', justifyContent: 'center', ...Platform.select({ web: { boxShadow: `0 8px 18px rgba(255,107,53,0.25)` }, default: { shadowColor: ORANGE, shadowOpacity: 0.25, shadowOffset: { width: 0, height: 8 }, shadowRadius: 12, elevation: 6 } }) },
  // ensure small breathing room below the cover/header
  headerCover: { height: 182, width: '100%', borderTopLeftRadius: 12, borderTopRightRadius: 12, overflow: 'hidden', marginBottom: 8 },
  headerCoverImage: { resizeMode: 'cover' },
  headerTopRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingTop: 18, paddingBottom: 8, height: 72 },
  headerCircle: { width: 44, height: 44, borderRadius: 22, backgroundColor: 'rgba(255,255,255,0.95)', alignItems: 'center', justifyContent: 'center' },
  headerCircleLeft: { position: 'absolute', left: 12, top: 18 },
  headerCircleRight: { position: 'absolute', right: 12, top: 18 },
  headerTitleWrap: { alignItems: 'center', justifyContent: 'center' },
  headerTitle: { color: '#fff', fontSize: 22, fontWeight: '700' },
  headerSubtitle: { color: 'rgba(255,255,255,0.95)', marginTop: 6 },
  tabsContainerOverlay: { paddingHorizontal: 12, paddingVertical: 8, paddingBottom: 16 },
  tabsStrip: { paddingHorizontal: 0, paddingVertical: 6 },
  tabsInnerStrip: { flexDirection: 'row', alignItems: 'stretch', backgroundColor: 'rgba(0,0,0,0.22)', borderTopLeftRadius: 22, borderTopRightRadius: 22, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, paddingVertical: 0, paddingHorizontal: 0, overflow: 'hidden' },
  tabSegment: { minWidth: 96, paddingHorizontal: 18, paddingVertical: 8, alignItems: 'center', justifyContent: 'center', borderRadius: 0 },
  tabSegmentFirst: { borderTopLeftRadius: 22, borderBottomLeftRadius: 0 },
  tabSegmentLast: { borderTopRightRadius: 22, borderBottomRightRadius: 0 },
  tabSegmentActive: { backgroundColor: ORANGE },
  tabSegmentTitle: { fontSize: 14, color: '#fff', fontWeight: '700' },
  tabSegmentTitleActive: { color: '#fff' },
  tabSegmentSub: { fontSize: 12, color: 'rgba(255,255,255,0.9)', marginTop: 4 },
  tabAddDaySegment: { minWidth: 56, paddingHorizontal: 12, paddingVertical: 8, alignItems: 'center', justifyContent: 'center' },
  tabsWrapper: { position: 'absolute', left: 0, right: 0, bottom: 0 },
  teamEditToggle: { position: 'absolute', right: 56, top: 18, zIndex: 40 },
  // position the small toggle centered under the pencil icon (pencil circle is 44px)
  teamEditToggleUnderPencil: { position: 'absolute', right: 14, top: 64, zIndex: 50 },
  teamEditToggleAtRightCircle: { position: 'absolute', right: 12, top: 18, zIndex: 60, alignItems: 'center' },
  teamEditLabel: { position: 'absolute', right: 6, top: 62, color: '#fff', fontSize: 12 },
  tabIndicator: { position: 'absolute', height: 8, backgroundColor: ORANGE, borderRadius: 6, bottom: 0, left: 0 },

  modalOverlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.35)', alignItems: 'center', justifyContent: 'center' },
  modalOverlayMobile: { paddingHorizontal: 0 },
  modalOverlayDesktop: { paddingHorizontal: 24 },
  modalCard: { backgroundColor: '#fff', borderRadius: 12, padding: 16, ...Platform.select({ web: { boxShadow: '0 10px 30px rgba(0,0,0,0.12)' }, default: { shadowColor: '#000', shadowOpacity: 0.12, shadowOffset: { width: 0, height: 10 }, shadowRadius: 20, elevation: 6 } }) },
  modalCardMobile: { width: 520, maxWidth: '92%' },
  modalCardDesktop: { width: 480, maxWidth: 480 },
  modalTitle: { fontSize: 16, fontWeight: '700', marginBottom: 8 },
  modalLabel: { fontSize: 12, color: '#6B7280', marginTop: 8, marginBottom: 4 },
  modalInput: { borderWidth: 1, borderColor: '#E5E7EB', borderRadius: 8, paddingVertical: 8, paddingHorizontal: 10 },
  modalActions: { flexDirection: 'row', justifyContent: 'flex-end', gap: 12, marginTop: 12 },
  modalBtn: { paddingVertical: 8, paddingHorizontal: 10 },
  
  typeGrid: { 
    flexDirection: 'row', 
    flexWrap: 'wrap', 
    gap: 8, 
    marginBottom: 12,
    justifyContent: 'flex-start',
  },
  typeButton: { 
    flex: 1,
    flexBasis: '18%',
    maxWidth: '19%',
    minWidth: 60,
    alignItems: 'center', 
    justifyContent: 'center',
    paddingVertical: 8, 
    paddingHorizontal: 2,
    borderRadius: 8, 
    borderWidth: 1.5, 
    borderColor: ORANGE,
    backgroundColor: '#FFF7ED',
  },
  typeButtonActive: { 
    backgroundColor: ORANGE, 
    borderColor: ORANGE,
    ...Platform.select({ web: { boxShadow: '0 6px 18px rgba(255,167,77,0.18)' }, default: { shadowColor: ORANGE, shadowOpacity: 0.25, shadowOffset: { width: 0, height: 4 }, shadowRadius: 8, elevation: 4 } }),
  },
  typeButtonText: { 
    fontSize: 9, 
    color: ORANGE,
    fontWeight: '600',
    marginTop: 3,
  },
  typeButtonTextActive: { 
    color: '#fff', 
    fontWeight: '700',
  },
  cardLibraryButton: {
    flexBasis: '58%',
    maxWidth: '60%',
    minWidth: 180,
    flexDirection: 'row',
    gap: 6,
  },
  
  modeRow: { flexDirection: 'row', flexWrap: 'wrap', gap: 8, marginBottom: 8 },
  modePill: { flexDirection: 'row', alignItems: 'center', gap: 6, paddingVertical: 6, paddingHorizontal: 10, borderRadius: 999, borderWidth: 1, borderColor: '#E5E7EB', marginRight: 8, marginBottom: 8, backgroundColor: '#fff' },
  modePillActive: { backgroundColor: ORANGE, borderColor: ORANGE },
  modePillText: { fontSize: 12, color: '#374151' },
  modePillTextActive: { color: '#fff', fontWeight: '700' },

  inlineTimeOverlay: { position: 'absolute', left: 0, right: 0, bottom: 0, alignItems: 'center', padding: 12 },
  inlineTimeCard: { width: 360, maxWidth: '92%', backgroundColor: '#fff', borderRadius: 12, padding: 12, ...Platform.select({ web: { boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }, default: { shadowColor: '#000', shadowOpacity: 0.12, shadowOffset: { width: 0, height: 8 }, shadowRadius: 16, elevation: 4 } }) },

  addItemPage: { 
    flex: 1, 
    backgroundColor: '#F9FAFB',
  },
  addItemContent: { 
    padding: 20,
    paddingBottom: 100,
  },
  addItemTitle: { 
    fontSize: 24, 
    fontWeight: '700', 
    color: '#111827',
    marginBottom: 24,
  },
  cardModeSelector: {
    flexDirection: 'row',
    gap: 12,
    marginTop: 16,
    marginBottom: 24,
  },
  cardModeButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: ORANGE,
    backgroundColor: '#FFF7ED',
  },
  cardModeButtonActive: {
    backgroundColor: ORANGE,
    borderColor: ORANGE,
  },
  cardModeButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: ORANGE,
  },
  cardModeButtonTextActive: {
    color: '#fff',
    fontWeight: '700',
  },
  placeholderBox: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 48,
    backgroundColor: '#fff',
    borderRadius: 16,
    borderWidth: 2,
    borderColor: '#E5E7EB',
    borderStyle: 'dashed',
    marginVertical: 24,
  },
  placeholderText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#6B7280',
    marginTop: 16,
  },
  placeholderSubtext: {
    fontSize: 13,
    color: '#9CA3AF',
    marginTop: 4,
    textAlign: 'center',
  },
  addItemActions: {
    flexDirection: 'row',
    gap: 12,
    marginTop: 32,
  },
  addItemButton: {
    flex: 1,
    paddingVertical: 14,
    paddingHorizontal: 20,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  addItemButtonCancel: {
    backgroundColor: '#F3F4F6',
    borderWidth: 1,
    borderColor: '#D1D5DB',
  },
  addItemButtonSave: {
    backgroundColor: ORANGE,
  },
  addItemButtonText: {
    fontSize: 16,
    fontWeight: '700',
    color: '#374151',
  },

  // ShareButton 样式
  shareButtonContainer: {
    marginHorizontal: 0,
    marginVertical: 0,
    paddingVertical: 10,
    paddingHorizontal: 12,
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
});
